<template>
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="18"
        height="18"
        viewBox="0 0 18 18"
        fill="none"
    >
        <path
            d="M8.46196 0.00483415C13.2894 -0.154166 17.3327 3.62869 17.495 8.45611C17.657 13.2836 13.877 17.3292 9.04965 17.4948C4.21778 17.6603 0.167386 13.8757 0.00503097 9.0438C-0.157324 4.21182 3.62987 0.163962 8.46196 0.00483415Z"
            fill="#FE101E"
        />
        <path
            d="M8.39833 1.41038C8.46387 1.40743 8.52945 1.40555 8.59505 1.40475C10.5645 1.36427 12.4674 2.11849 13.8741 3.49726C15.2714 4.85519 16.0707 6.71347 16.0955 8.66173C16.1099 10.1523 15.6831 11.5237 14.6225 12.5992C13.6628 13.5757 12.3531 14.1286 10.984 14.1356C8.79053 14.1469 7.11752 12.8252 7.14244 10.5181C7.15048 9.77243 7.31661 9.17581 7.74006 8.55961C8.65042 7.23492 10.0605 6.70003 11.6176 6.69816C12.2283 6.73167 12.6994 6.7616 13.2752 6.97887C13.3618 6.69125 13.4085 6.41545 13.475 6.1254C13.5662 5.728 13.6541 5.3506 13.7195 4.94696C12.5487 4.45492 11.8383 4.22622 10.5698 4.10432C6.34069 3.69797 1.7714 6.57998 1.9215 11.1702C1.92267 11.2063 1.92037 11.2515 1.89352 11.2743L1.86708 11.2656C1.63763 10.9097 1.52722 9.69544 1.50013 9.25403C1.36029 7.25354 2.03915 5.28207 3.38106 3.79181C4.67525 2.33414 6.46438 1.52734 8.39833 1.41038Z"
            fill="white"
        />
    </svg>
</template>
